import React, { Component } from 'react'
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton'
import { localize } from '../../util/Localizer'
import { Colors } from '../../theme'
import Icon from '@material-ui/core/Icon'
import Tooltip from '../../controls/Tooltip'

const styles = {
  fileNameStretch: 'file-name spacer',
  disabled: 'disabled',
  loading: 'loading',
  spacer: 'spacer',
  imagePreview: 'image-preview',
  preview: 'preview',
  previewItem: 'preview-item'
}

class FileUploadPreview extends Component {
  constructor (props) {
    super(props)

    this.readerOnLoadCallback = this.readerOnLoadCallback.bind(this)
    this.reader = new window.FileReader()

    this.state = {
      loading: true
    }
  }

  componentDidMount () {
    this.displayData(this.props.data)
  }

  componentWillUnmount () {
    this.reader.onload = null
    delete this.reader
  }

  readerOnLoadCallback (src, type) {
    this.setState({
      src,
      type,
      loading: false
    })
  }

  displayData (file) {
    if (!file) {
      return
    }

    let type = file.type

    if (type.match('text')) {
      type = 'text'
    } else if (type.match('image')) {
      type = 'image'
    }

    this.reader.onload = e => this.readerOnLoadCallback(e.target.result, type)
    this.reader.readAsDataURL(file)
  }

  render () {
    let loading = null
    if (this.state.loading) {
      loading = localize('pages.SubmitAClaim.PhotoUpload.loadingData')
    }

    let preview = null
    if (!this.state.loading && !this.props.data.loading) {
      if (this.state.type === 'image') {
        preview =
          <img
            alt='preview'
            src={this.state.src}
            className={styles.imagePreview}
          />
      } else {
        preview = <Icon color='primary' style={{ margin: '0px 20px' }}>insert_drive_file</Icon>
      }
    }

    const classes = [
      styles.previewItem,
      this.props.data.loading ? styles.disabled : ''
    ]
      .join(' ')
      .trim()

    return (
      <Paper className={classes} style={{ color: Colors.Palette.primaryTextColor, height: 60 }}>
        {loading}
        {preview}
        <div className={styles.fileNameStretch}>{this.props.data.name}</div>
        {this.props.onRemove &&
          <Tooltip title={localize('pages.SubmitAClaim.PhotoUpload.removeFile')} placement="bottom">
            <IconButton
              onClick={this.props.onRemove}
            >
              <Icon>cancel</Icon>
            </IconButton>
          </Tooltip>
        }
      </Paper>
    )
  }
}

export default FileUploadPreview



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/FileUploadPreview.js